import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAlert } from "@inbody/core";
import { useAuth } from "@inbody/keycloak";
function AuthGuard({
  children,
  roles,
  redirectUrl,
  isCheckCorporateCode,
  rootAdminRole
}) {
  const { t } = useTranslation("ui");
  const { checkRoles } = useAuth();
  const hasAuth = checkRoles(
    roles || "ADMIN",
    isCheckCorporateCode,
    rootAdminRole
  );
  const { confirmAlert } = useAlert();
  const navigate = useNavigate();
  useEffect(() => {
    if (!hasAuth) {
      confirmAlert({
        title: t("페이지에 접근할 수 있는 권한이 없습니다."),
        icon: "error",
        showCancelButton: false,
        onConfirm: () => {
          navigate(redirectUrl || "/");
        }
      });
    }
  }, [hasAuth, navigate]);
  return hasAuth ? children : null;
}
export {
  AuthGuard
};
